import _ from "lodash";
import getSsn from "../components/common/Ssn";
import { getDobDate, getDodDate } from "../components/common/DisplayDate";

function pickDeep(collection, predicate, res) {
  return _.transform(collection, (memo, val, key) => {
    if (_.isObject(val)) {
      val = pickDeep(val, predicate, res);
    }
    if (_.isArray(collection)) {
      memo.push(val);
    } else {
      memo[key] = val;
    }
    if (key === predicate) {
      res.push(val);
    }
  });
}

const getAge = (node) => {
  let dod = _.get(node, "DOD[0]._");
  if(!dod) dod = _.get(node, "DODInfo[0].DOD[0]._");
  let age = _.get(node, "age[0]._");
  if(!age) age = _.get(node, "DOBInfo[0].age[0]._");
  if (
    (dod !== undefined && dod !== "") ||
    _.find(node, (a) => a.SSNDeceased === "Yes")
  ) {
    return "Deceased";
  } else if (age === undefined || age === "") {
    return "Unknown";
  }
  return age;
};

const getSsnLocation = (node, ssnInfo) => {
  if (ssnInfo.length === 0) return "";
  const ssnState = _.get(ssnInfo[0][0], "SSNState[0]._", "");
  if (ssnState !== "") {
    return ssnState;
  }
  const issuedLocation = _.get(ssnInfo[0][0], "issuedLocation[0]._", "");
  if (issuedLocation !== "") {
    return issuedLocation;
  }
  return _.get(
    node,
    "individual[0].AKAs[0].identity[0].SSNInfo[0].issuedLocation[0]._"
  );
};

const getSsnYear = (node, ssnInfo) => {
  if (ssnInfo.length === 0) return "";
  const ssnYears = _.get(ssnInfo[0][0], "SSNYears[0]._", "");
  if (ssnYears !== "") {
    return ssnYears;
  }
  const issuedYear = _.get(ssnInfo[0][0], "issuedStartDate[0].year[0]._", "");
  if (issuedYear !== "") {
    return issuedYear;
  }
  return _.get(
    node,
    "individual[0].AKAs[0].identity[0].SSNInfo[0].issuedStartDate[0].year[0]._"
  );
};

const GetPersonData = (node, userAccount) => {
  const personData = [];
  const ssn = [];
  pickDeep(node, "SSN", ssn);
  personData.age = getAge(node);
  personData.ssnCount = ssn.length;
  if (ssn && ssn.length > 0) {
    personData.ssnTiered = getSsn(_.get(ssn[0][0], "_"), { userAccount });
  }
  const ssnInfo = [];
  pickDeep(node, "SSNInfo", ssnInfo);
  personData.ssnLocation = getSsnLocation(node, ssnInfo);
  personData.ssnYear = getSsnYear(node, ssnInfo);
  const dobInfo = [];
  pickDeep(node, "DOBInfo", dobInfo);
  if (dobInfo && dobInfo.length > 0) {
    const dobNode = _.get(dobInfo[0][0], "DOB[0]");
    personData.dob = getDobDate(dobNode, { userAccount });
    const dodNode = _.get(dobInfo[0][0], "DOD[0]");
    personData.dod = getDodDate(dodNode, { userAccount });
  } else {
    const dobNode = _.get(node, "DOB[0]");
    personData.dob = getDobDate(dobNode, { userAccount });
    const dodNode = _.get(node, "DOD[0]");
    personData.dod = getDodDate(dodNode, { userAccount });
  }
  // Todo update resultId
  personData.weight = _.get(node, "$.weight", "");
  return personData;
};

export default GetPersonData;



// WEBPACK FOOTER //
// ./src/metadata/PersonMetadata.js